import { render, staticRenderFns } from "./TodoListModal.vue?vue&type=template&id=947bfe80&"
import script from "./TodoListModal.vue?vue&type=script&lang=js&"
export * from "./TodoListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports